import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Img1 from '../../images/dominique-feed-back.svg'
import Img2 from '../../images/fanny-feed-back.svg'
import Img3 from '../../images/arturo-feed-back.svg'
import paws1 from '../../images/paws-1.svg'
import paws2 from '../../images/paws-2.svg'
import icon3 from '../../images/testimonial-icon.svg'

const testimonials = [
    {
        id: '01',
        Des: "Mon chien aboyait sans cesse dès que je le laissais seul, ce qui était très stressant pour nous deux. Grâce à Laura, j’ai appris à comprendre ses angoisses. Maintenant, il reste beaucoup plus calme lorsqu’il est seul.",
        title: 'Dominique T.',
        Image: Img1,
    },
    {
        id: '02',
        Des: "J’ai recueilli un chien abandonné et je voulais être sûre de bien l’accompagner. Grâce aux conseils de Laura, il s’est vite senti en confiance et l’adaptation s’est faite en douceur",
        title: 'Fanny B.',
        Image: Img2,
    },
    {
        id: '03',
        Des: "Mon chien tirait tellement en laisse que les balades étaient devenues pénibles. Grâce à l’accompagnement de Laura, j’ai appris à le comprendre et à mieux gérer la situation. En quelques séances, il marche calmement à mes côtés et les promenades sont enfin un plaisir",
        title: 'Arturo M.',
        Image: Img3,
    },
]




const Testimonial = (props) => {
    const [currentSlide, setCurrentSlide] = React.useState(0);

    const settings = {
        dots: false,
        autoplay: true,
        infinite: true,
        arrows: true,
        speed: 1000,
        autoplaySpeed: 8000,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (current, next) => setCurrentSlide(next),
    };


    return (

        <section className={"" + props.tClass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-12">
                        <div className="section-title text-center" style={{ paddingTop: '60px' }}>
                            <span>Témoignages</span>
                            <h2>Ce que disent les dogs lovers</h2>
                        </div>

                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <div className="testimonial-image" style={{ width: '500px', height: '500px', overflow: 'hidden', borderRadius: '50%', margin: '0 auto' }}>
                            <img src={testimonials[currentSlide]?.Image} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="testimonial-slider">
                            <Slider {...settings}>
                                {testimonials.map((testitem, titem) => (
                                    <div key={titem}>
                                        <div className="icon">
                                            <img src={icon3} alt="" />
                                        </div>
                                        <h3>{testitem.Des}</h3>
                                        <div className="client-wrap">
                                            <div className="text">
                                                <h4>{testitem.title}</h4>

                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
            <div className="shape-1">
                <img src={paws1} alt="" />
            </div>
            <div className="shape-2">
                <img src={paws2} alt="" />
            </div>
        </section>
    );
}

export default Testimonial;







